import { useState, useEffect } from "react";
import ProjectDetailDesktop from "../ProjectDetail/ProjectDetailDesktop.js";
import ProjectDetailMobile from "../ProjectDetail/ProjectDetailMobile.js";

const ProjectDetail = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    // Function to check if device is mobile
    const checkIsMobile = () => {
      const width = window.innerWidth;
      const userAgent = navigator.userAgent;

      // Check for mobile screen size (768px is typical tablet/mobile breakpoint)
      const isMobileWidth = width < 768;

      // Check for mobile user agents
      const isMobileUserAgent =
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          userAgent
        );

      // Consider it mobile if either condition is true
      return isMobileWidth || isMobileUserAgent;
    };

    // Set initial state
    setIsMobile(checkIsMobile());

    // Add resize listener to handle screen size changes
    const handleResize = () => {
      setIsMobile(checkIsMobile());
    };

    window.addEventListener("resize", handleResize);

    // Cleanup listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // Render the appropriate component based on device type
  return isMobile ? <ProjectDetailMobile /> : <ProjectDetailDesktop />;
};

export default ProjectDetail;
